<app-loading
  [loading]="appLoading$ | async"
  [overlay]="true"
  [fixed]="true"
></app-loading>

<router-outlet></router-outlet>
